import { Button } from 'components-antd';
import { ICON_VARIANT_TYPE, Icons } from 'pages/Workshop/Forms/Icons';

import styles from './styles.module.scss';
import { useHistory } from 'react-router-dom';
import { routes } from 'settings/navigation/routes';

export const EditFormButton = ({ formDetails, selectedFormProcess }) => {
  const history = useHistory();

  const onEditClick = () => {
    history.push({
      pathname: routes.workshopFormProcessRequest,
      state: {
        voidedForm: false,
        createFormCopy: true,
        formDetails,
        name: formDetails?.formName,
        formProcessId: selectedFormProcess,
      },
    });
  };

  return (
    <div className={styles.buttonWrapper}>
      <Button variant="default" className={styles.editButton} onClick={onEditClick}>
        <div className={styles.editButtonContainer}>
          <Icons variant={ICON_VARIANT_TYPE.EDIT_PENCIL} className={styles.editIcon} />
          <div>Edit</div>
        </div>
      </Button>
    </div>
  );
};
